import axios from 'axios';
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { apiCall } from '../Apis/apiCall';

const AddClientPermissions = () => {
    const [permissionKey, setPermissionKey] = useState('');
    const [description, setDescription] = useState('');
    const [moduleName, setModuleName] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    const handleAddPermission = async () => {
        if (!permissionKey.trim() || !description.trim() || !moduleName.trim()) {
            setError("All fields are required.");
            return;
        }

        setIsLoading(true);
        setError('');
        setSuccess('');

        try {
            const payload = {
                permission_key: permissionKey,
                description: description,
                module_name: moduleName,
            };

            const response = await apiCall(
                "post",
                "/add-client-permission",
                payload,
                navigate
            );

            if (response?.data?.success) {
                setSuccess("Permission added successfully!");
                setError("");
                setPermissionKey("");
                setDescription("");
                setModuleName("");
                setTimeout(() => {
                    navigate("/client-permissions");
                }, 2000);
            } else {
                setError(response?.data?.message || "Failed to add permission.");
            }
        } catch (error) {
            setError(error?.message || "Error adding permission.");
            setSuccess("");
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div>
            <div className="card h-100 p-0 radius-12 overflow-hidden">
                <div className="card-body p-40">
                    <div>
                        <div className="row">
                            <div className="col-sm-6">
                                <div className="mb-20">
                                    <label
                                        htmlFor="permissionKey"
                                        className="form-label fw-semibold text-primary-light text-sm mb-8"
                                    >
                                        Permission Key <span className="text-danger-600">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control radius-8"
                                        id="permissionKey"
                                        value={permissionKey}
                                        onChange={(e) => setPermissionKey(e.target.value)}
                                        placeholder="Enter Permission Key"
                                        disabled={isLoading}
                                    />
                                </div>
                            </div>
                            <div className="col-sm-6">
                                <div className="mb-20">
                                    <label
                                        htmlFor="description"
                                        className="form-label fw-semibold text-primary-light text-sm mb-8"
                                    >
                                        Description <span className="text-danger-600">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control radius-8"
                                        id="description"
                                        value={description}
                                        onChange={(e) => setDescription(e.target.value)}
                                        placeholder="Enter Description"
                                        disabled={isLoading}
                                    />
                                </div>
                            </div>
                            <div className="col-sm-6">
                                <div className="mb-20">
                                    <label
                                        htmlFor="moduleName"
                                        className="form-label fw-semibold text-primary-light text-sm mb-8"
                                    >
                                        Module Name <span className="text-danger-600">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control radius-8"
                                        id="moduleName"
                                        value={moduleName}
                                        onChange={(e) => setModuleName(e.target.value)}
                                        placeholder="Enter Module Name"
                                        disabled={isLoading}
                                    />
                                </div>
                            </div>
                            <div className="col-sm-12">
                                <div className="mb-20">
                                    {error && (
                                        <div className="alert alert-danger alert-dismissible fade show mb-3" role="alert">
                                            {error}
                                            <button
                                                type="button"
                                                className="btn-close"
                                                onClick={() => setError('')}
                                            ></button>
                                        </div>
                                    )}
                                    {success && (
                                        <div className="alert alert-success alert-dismissible fade show mb-3" role="alert">
                                            {success}
                                            <button
                                                type="button"
                                                className="btn-close"
                                                onClick={() => setSuccess('')}
                                            ></button>
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className="col-sm-12">
                                <div className="d-flex align-items-center justify-content-center gap-3 mt-24">
                                    <Link
                                        to="/client-permissions"
                                        className="border border-danger-600 bg-hover-danger-200 text-danger-600 text-md px-40 py-11 radius-8 text-decoration-none"
                                    >
                                        Cancel
                                    </Link>
                                    <button
                                        type="button"
                                        className="btn btn-primary-600 border border-primary-600 text-md px-24 py-12 radius-8"
                                        onClick={handleAddPermission}
                                        disabled={isLoading}
                                    >
                                        {isLoading ? 'Saving...' : 'Save Change'}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AddClientPermissions;